{
	"name": "sre-portal-front",
	"version": "0.0.1",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"build": "ng build",
		"build:dev": "ng build --configuration development",
		"build:homolog": "ng build --configuration homolog",
		"build:pre-prod": "ng build --configuration production",
		"watch": "ng build --watch --configuration development",
		"prepare": "husky || true",
		"p:check": "prettier --config ./.prettierrc --list-different \"src/{app,environments,assets}/**/*{.ts,.js,.json,.css,.scss,.html}\"",
		"p:fix": "prettier --config ./.prettierrc --write \"src/{app,environments,assets}/**/*{.ts,.js,.json,.css,.scss,.html}\"",
		"lint": "ng lint"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "^19.1.7",
		"@angular/cdk": "^19.1.5",
		"@angular/common": "^19.1.7",
		"@angular/compiler": "^19.1.7",
		"@angular/core": "^19.1.7",
		"@angular/forms": "^19.1.7",
		"@angular/material": "^19.1.5",
		"@angular/platform-browser": "^19.1.7",
		"@angular/platform-browser-dynamic": "^19.1.7",
		"@angular/router": "^19.1.7",
		"@angular/service-worker": "^19.1.7",
		"@datadog/browser-rum": "^6.23.0",
		"@fortawesome/angular-fontawesome": "^1.0.0",
		"@fortawesome/fontawesome-svg-core": "^6.7.2",
		"@fortawesome/free-brands-svg-icons": "^6.7.2",
		"@fortawesome/free-regular-svg-icons": "^6.7.2",
		"@fortawesome/free-solid-svg-icons": "^6.7.2",
		"@mottu-ops/sso": "^4.1.1",
		"keycloak-angular": "^19.0.2",
		"keycloak-js": "^26.2.1",
		"rxjs": "~7.8.2",
		"tslib": "^2.3.0",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^19.1.8",
		"@angular-eslint/builder": "^19.0.0",
		"@angular-eslint/eslint-plugin": "^19.0.0",
		"@angular-eslint/eslint-plugin-template": "^19.0.0",
		"@angular-eslint/schematics": "^19.0.0",
		"@angular-eslint/template-parser": "^19.0.0",
		"@angular/cli": "^19.1.8",
		"@angular/compiler-cli": "^19.1.7",
		"@commitlint/config-conventional": "^19.7.1",
		"@typescript-eslint/eslint-plugin": "~8.8.0",
		"@typescript-eslint/parser": "~8.8.0",
		"eslint": "^8.12.0",
		"eslint-config-prettier": "^9.1.0",
		"eslint-plugin-prettier": "^4.2.0",
		"husky": "^9.1.7",
		"lint-staged": "^15.4.3",
		"prettier": "^3.5.3",
		"typescript": "~5.7.2"
	},
	"lint-staged": {
		"*.{js,css,md,ts,html,json}": "prettier --write"
	}
}
